export default __webpack_public_path__ + "static/media/energy_saving.6233b5a0.png";